<template>
  <div>
    <a-modal
      width="40%"
      title="编辑微课视频"
      destroy-on-close
      :visible.sync="visible"
      append-to-body
      ok-text="提交"
      cancel-text="取消"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <div class="card-item">
        <div class="mb15">
          <div class="flex align-items-center mb15">
            <img class="img-box-2" src="@/assets/images/img40.png" alt="" />
            <div class="text1">
              思政微课视频
              <span style="color: #f6350f">*</span>
            </div>
          </div>
          <div>
            <a-upload
              :file-list="fileList"
              accept=".mp4"
              :remove="(file, fileList) => handleRemove(file, fileList)"
              :disabled="loading"
              :before-upload="(file, fileList) => beforeUpload(file, fileList)"
            >
              <a-button :disabled="loading" :loading="loading">
                <a-icon type="upload" /> 上传附件
              </a-button>
              <span class="text2">请上传视频</span>
            </a-upload>
          </div>
        </div>
        <div class="mt30">
          <div>
            <div class="main-text-style">
              <span style="color: #f6350f">*</span>思政元素
            </div>
            <div class="pl16">
              <a-select
                mode="tags"
                style="width: 100%"
                v-model="info.ideologicalElement"
                placeholder="请选择思政元素"
              >
                <a-select-option v-for="item in ysList" :value="item.name">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </div>
          </div>
        </div>
        <div class="preview-pop-box" v-if="showvideo">
          <div class="preview-boxs" style="height: 600px">
            <videopreview
              :previewUrl="previewUrl"
              @closePreview="showvideo = false"
            ></videopreview>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>
    <script>
import { getAction, postAction, putAction, deleteAction } from "@/api/index";
import { baseURL } from "@/utils/request.js";
import videopreview from "@/components/common/videopreview";
export default {
  name: "",
  data() {
    return {
      visible: false,
      info: {
        ideologicalElement: [],
        sourceType: "alioss",
        aliId: "",
      },
      ysList: [],
      //    applyFiles: [],
      path: baseURL,
      loading: false,
      type4: false,
      type5: false,
      type6: false,
      submitLoading: null,
      fileList: [],
      isEdit: false,
      showvideo: false,
      previewUrl: "",
      file: "",
      sourceType: "alioss",
      timeout: "",
      partSize: "",
      parallel: "",
      retryCount: "",
      retryDuration: "",
      region: "cn-beijing",
      userId: "1104845979036938",
      uploadDisabled: true,
      resumeDisabled: true,
      statusText: "",
      taskId: null,
      detailId: null,
    };
  },
  methods: {
    init(mode, data, taskId, detailId) {
      console.log("🚀 ~ init ~ data:", data);
      console.log("🚀 ~ init ~ taskIds:", taskId);
      this.visible = true;
      this.info = { ...data };
      this.taskId = taskId;
      this.detailId = detailId;
      this.fileList = [];
      let fileItem = {};
      fileItem.path = data.filePath;
      fileItem.name = data.name;
      fileItem.uid = -100;
      this.fileList.push(fileItem);
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      this.info.fileName = "";
      this.info.filePath = "";
    },
    beforeUpload(file, fileList) {
      this.handleUpload(file, fileList);
      return false;
    },
    createUploader() {
      let self = this;
      let uploader = new AliyunUpload.Vod({
        timeout: self.timeout || 60000,
        partSize: self.partSize || 1048576,
        parallel: self.parallel || 5,
        retryCount: self.retryCount || 3,
        retryDuration: self.retryDuration || 2,
        region: self.region,
        userId: self.userId,
        // 添加文件成功
        addFileSuccess: function (uploadInfo) {
          self.uploadDisabled = false;
          self.resumeDisabled = false;
          self.statusText = "添加文件成功, 等待上传...";
          self.loading = true;
        },
        // 开始上传
        onUploadstarted: function (uploadInfo) {
          // 如果是 UploadAuth 上传方式, 需要调用 uploader.setUploadAuthAndAddress 方法
          // 如果是 UploadAuth 上传方式, 需要根据 uploadInfo.videoId是否有值，调用点播的不同接口获取uploadauth和uploadAddress
          // 如果 uploadInfo.videoId 有值，调用刷新视频上传凭证接口，否则调用创建视频上传凭证接口
          // 注意: 这里是测试 demo 所以直接调用了获取 UploadAuth 的测试接口, 用户在使用时需要判断 uploadInfo.videoId 存在与否从而调用 openApi
          // 如果 uploadInfo.videoId 存在, 调用 刷新视频上传凭证接口(https://help.aliyun.com/document_detail/55408.html)
          // 如果 uploadInfo.videoId 不存在,调用 获取视频上传地址和凭证接口(https://help.aliyun.com/document_detail/55407.html)

          // self.$emit("handleIsSubmt", true);
          // console.log("444444",uploadInfo);
          self.$forceUpdate();
          self.loading = true;
          if (!uploadInfo.videoId) {
            // let createUrl = 'https://demo-vod.cn-shanghai.aliyuncs.com/voddemo/CreateUploadVideo?Title=testvod1&FileName=aa.mp4&BusinessType=vodai&TerminalType=pc&DeviceModel=iPhone9,2&UUID=59ECA-4193-4695-94DD-7E1247288&AppVersion=1.0.0&VideoId=5bfcc7864fc14b96972842172207c9e6'
            // let createUrl='https://vod.cn-shanghai.aliyuncs.com/?Action=CreateUploadVideo' +
            //   '&FileName=' + uploadInfo.file.name+
            //   '&title=UploadTest'

            // axios.get(createUrl).then(({data}) => {
            //   let uploadAuth = data.UploadAuth
            //   let uploadAddress = data.UploadAddress
            //   let videoId = data.VideoId
            //   uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress,videoId)
            // })

            // var params = {
            //   FileName:uploadInfo.file.name,
            //   Title:uploadInfo.file.name
            // }
            const params = new FormData();
            params.append("FileName", uploadInfo.file.name);
            params.append("Title", uploadInfo.file.name.split(".")[0]);
            params.append("CateId", "11095");
            postAction("/sys/video/CreateUploadVideo", params).then((res) => {
              // console.log(res,'4444444444444444444')
              let uploadAuth = res.result.uploadAuth;
              let uploadAddress = res.result.uploadAddress;
              let videoId = res.result.videoId;
              uploader.setUploadAuthAndAddress(
                uploadInfo,
                uploadAuth,
                uploadAddress,
                videoId
              );
            });
            self.statusText = "文件开始上传...";
          } else {
            // 如果videoId有值，根据videoId刷新上传凭证
            // https://help.aliyun.com/document_detail/55408.html?spm=a2c4g.11186623.6.630.BoYYcY
            // let refreshUrl = 'https://demo-vod.cn-shanghai.aliyuncs.com/voddemo/RefreshUploadVideo?BusinessType=vodai&TerminalType=pc&DeviceModel=iPhone9,2&UUID=59ECA-4193-4695-94DD-7E1247288&AppVersion=1.0.0&Title=haha1&FileName=xxx.mp4&VideoId=' + uploadInfo.videoId
            // axios.get(refreshUrl).then(({data}) => {
            //   let uploadAuth = data.UploadAuth
            //   let uploadAddress = data.UploadAddress
            //   let videoId = data.VideoId
            //   uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress,videoId)
            // })
            // console.log("444444",'这里');
            postAction(
              `/sys/video/refresVideoPlayAuth?videoId=${uploadInfo.videoId}`
            ).then((res) => {
              let uploadAuth = res.result.uploadAuth;
              let uploadAddress = res.result.uploadAddress;
              let videoId = res.result.videoId;
              uploader.setUploadAuthAndAddress(
                uploadInfo,
                uploadAuth,
                uploadAddress,
                videoId
              );
            });
          }
        },
        // 文件上传成功
        onUploadSucceed: function (uploadInfo) {
          self.statusText = "文件上传成功!";

          const params = {
            // name: uploadInfo.file.name,
            // path: uploadInfo.object,
            // size: uploadInfo.file.size,
            // fileId: uploadInfo.videoId,
            aliId: uploadInfo.videoId,
            fileType: "VIDEO", //	资源源文件类型
            fileUrl: "", //	资源源文件地址
            name: uploadInfo.file.name, //	资源名称
            previewUrl: "", //	转换后文件地址
            resourceDuration: 0, //	资源时长
            sourceType: "alioss",
            uid: uploadInfo.file.uid,
            format: ".mp4",
          };
          console.log("sssss", params);
          self.loading = false;
          self.uploadFiles(params);
          self.info.aliId = uploadInfo.videoId;
          // self.$emit("uploadFile", params);
          self.fileList.forEach((item, index) => {
            if (item) {
              self.fileList.splice(index, 1);
            }
          });
          self.fileList.push(params);
          // self.showProgress = false;
          // self.$emit("handleIsSubmt", false);
        },
        // 文件上传进度，单位：字节, 可以在这个函数中拿到上传进度并显示在页面上
        onUploadProgress: function (uploadInfo, totalSize, progress) {
          let progressPercent = Math.ceil(progress * 100);
          self.authProgress = progressPercent;
          self.percent = progressPercent;
          self.statusText = "文件上传中...";
          console.log(progressPercent, "3333");
          self.loading = true;
          if (progressPercent == 100) {
          }
        },
        // 上传凭证超时
        onUploadTokenExpired: function (uploadInfo) {
          // 上传大文件超时, 如果是上传方式一即根据 UploadAuth 上传时
          // 需要根据 uploadInfo.videoId 调用刷新视频上传凭证接口(https://help.aliyun.com/document_detail/55408.html)重新获取 UploadAuth
          // 然后调用 resumeUploadWithAuth 方法, 这里是测试接口, 所以我直接获取了 UploadAuth
          // let refreshUrl = 'https://demo-vod.cn-shanghai.aliyuncs.com/voddemo/RefreshUploadVideo?BusinessType=vodai&TerminalType=pc&DeviceModel=iPhone9,2&UUID=59ECA-4193-4695-94DD-7E1247288&AppVersion=1.0.0&Title=haha1&FileName=xxx.mp4&VideoId=' + uploadInfo.videoId
          // axios.get(refreshUrl).then(({data}) => {
          //   let uploadAuth = data.UploadAuth
          //   uploader.resumeUploadWithAuth(uploadAuth)
          // })

          postAction(
            `/sys/video/refresVideoPlayAuth?videoId=${uploadInfo.videoId}`
          ).then((res) => {
            let uploadAuth = res.result.uploadAuth;
            uploader.resumeUploadWithAuth(uploadAuth);
          });
          self.loading = false;
          self.fileList = [];
          self.statusText = "文件超时...";
        },
        onUploadFailed() {
          console.log("22222");
          self.$message.error("上传失败");
          self.fileList = [];
          self.loading = false;
        },
      });
      return uploader;
    },
    uploadFiles(params) {
      // let obj = {
      //   //添加资源参数
      //   aliId: params.aliId, // 阿里云存放id
      //   // courseId: this.$store.state.courseId, //  课程id
      //   // coverImg: data.coverImgpath, //  封面图片
      //   fileType: params.fileType, // 资源源文件类型
      //   fileUrl: params.fileUrl, // 资源源文件地址
      //   // id:"",            // 主键
      //   name: params.name, // 资源名称
      //   previewUrl: params.previewUrl, // 转换后文件地址
      //   resourceDuration: params.resourceDuration, // 资源时长
      //   // sort: 0, //  排序
      //   sourceType: params.sourceType, // 来源类型
      //   // startClassId: this.$store.state.constructionId, //  开课id
      //   // teachContentId:"",   //  教学内容内容id
      //   // teachingWeek: this.params2.teachingWeek, // 教学周
      //   uid: params.uid,
      // };
      this.info.aliId = params.aliId;
      this.info.fileName = params.name;
      this.info.filePath = params.fileUrl;
      this.fileList = [];
      let fileItem = {};
      fileItem.path = params.fileUrl;
      fileItem.name = params.name;
      fileItem.uid = -100;
      this.fileList.push(fileItem);
      console.log(params);
      // if (params.aliId) {
      //   obj.format = params.format;
      // }
      // this.sourceUploadList.push(obj);
      // console.log(this.sourceUploadList)
    },
    handleUpload(file, fileList) {
      if (this.fileList.length >= 1) {
        this.$message.error("思政微课只能上传一个文件,请移除后再上传");
        return;
      }
      if (file.type == "video/mp4") {
        console.log("此处应该使用阿里云的视频上传");
        this.file = file;
        // 简化的阿里云上传视频
        var userData = '{"Vod":{}}';
        this.uploader = this.createUploader();
        this.uploader.addFile(this.file, null, null, null, userData);
        this.uploader.startUpload();
        this.fileList = fileList;
      } else {
        this.$message.error("请上传规定格式的文件");
        return false;
      }

      // this.loading = true;
      // const formData = new FormData();
      // formData.append("file", file);
      // formData.append("biz", "linxuan");
      // fileUpdate(formData).then((res) => {
      //   if (res.code === 0) {
      //     this.$message.success(`上传成功`);
      //     let fileItem = {};
      //     fileItem.path = res.message;
      //     fileItem.name = file.name;
      //     fileItem.uid = file.uid;
      //     this.fileList.push(fileItem);
      //     this.loading = false;
      //   } else {
      //     this.$message.error("上传失败");
      //   }
      // });
    },
    handleOk() {
      console.log("this.info", this.info);
      let params = {
        taskId: this.taskId,
        afterJson: JSON.stringify({
          ideologicalElement:
            typeof this.info.ideologicalElement == "string"
              ? this.info.ideologicalElement
              : this.info.ideologicalElement.join(),
          filePath: this.fileList[0].path,
          name: this.fileList[0].name,
          applyId: this.info.applyId,
          aliId: this.info.aliId,
          sourceType: this.info.sourceType,
        }),
        detailId: this.detailId,
      };
      postAction("/audit/lxAuditTask/reSubmitTask", params).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.message || "提交成功");
          this.visible = false;
          this.reasonText = "";
          this.$emit("init");
        } else {
          this.$message.error(res.message || "提交失败");
          this.visible = false;
          this.reasonText = "";
        }
      });
    },
    handleCancel() {
      this.visible = false;
    },
  },
  mounted() {},
};
</script>
    
<style scoped lang="scss">
.card-item {
  .title-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 700;
    border-bottom: 1px solid #d9d9d9;

    .title-text {
      color: #2155b5;
      font-size: 20px;
      font-weight: bold;
      height: 40px;
      line-height: 40px;
      border-bottom: 3px solid #2155b5;
      padding: 0px 4px;
    }

    .btn-action {
      width: 100px;
      height: 30px;
      border-radius: 6px;
      font-weight: 400;
      cursor: pointer;
      line-height: 30px;
      margin-right: 10px;
      text-align: center;
    }
  }
}

.text1 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}

.mb15 {
  margin-bottom: 15px;
}

.mb15-item {
  border-bottom: 1px solid #e4e0e0;
  padding-bottom: 30px;
  margin-bottom: 30px;
}

.img-box {
  width: 18px;
  height: 18px;
  margin-right: 10px;
}

.img-box-2 {
  width: 19px;
  height: 19px;
  margin-right: 10px;
}

.text2 {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  margin: 14px 0 15px 10px;
}

.img-box-4 {
  width: 12px;
  height: 12px;
  margin-right: 10px;
  margin-bottom: 5px;
}

.submit-btn {
  width: 116px;
  height: 40px;
  margin: 0 auto;
  color: #fff;
  background: #2155b5;
  line-height: 38px;
  text-align: center;
  border-radius: 10px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  cursor: pointer;
}

.big-box {
  width: 253px;
  margin: 40px auto 0px;
}

.file-input-box {
  color: #2155b5;
}

.file {
  position: relative;
  width: 156px;
  height: 40px;
  background: #fff;
  border: 1px solid #2155b5;
  border-radius: 4px;
  padding: 4px 12px;
  overflow: hidden;
  color: #575757;
  text-decoration: none;
  text-indent: 0;
  line-height: 20px;
  margin-bottom: 15px;
}

.file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
}

.file:hover {
  background: rgba(218, 218, 218, 0.2);
  color: #000;
  text-decoration: none;
}

/deep/ .ant-select-selection--multiple {
  width: 100%;
  padding: 10px 20px;
  height: 54px;
  font-size: 18px !important;
  color: #999999;
}

.mt30 {
  margin-top: 20px;
}

.main-text-style {
  font-size: 19px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-bottom: 15px;
}

.preview-pop-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);

  .preview-box {
    margin: 50px auto;
    width: 1177px;
    height: 90%;
  }

  .preview-boxs {
    margin: 50px auto;
    width: 950px;
    height: 700px;
    overflow: hidden;
  }

  .preview-box-fullscreen {
    width: 100vw;
    height: 100vh;
  }
}
</style>